import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NavbarComponent from './Navbar';
import FooterComponent from './Footer';
import { COMMON_CONSTANTS } from '../constants/Common'
import { AXIOS_HELPERS } from '../helpers/Axios'
import Seo from '../components/Seo';
import('../css/Footer.css');
import('../css/Navbar.css');
import('../css/Signup.css');

const { config: { base_url } } = COMMON_CONSTANTS
const { MakeAxiosCall } = AXIOS_HELPERS


// const base_url = process.env.REACT_APP_API_BASE_URL
// const base_url = "https://www.codingsikho.online/api/v1"


// console.log('base url', base_url)
const Signup = () => {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        password: '',
        confPassword: '',
    });

    const [errors, setErrors] = useState({});
    const [isSuccessMessage, setisSuccessMessage] = useState(false)
    const navigate = useNavigate();

    const validateForm = () => {
        const newErrors = {};

        if (!formData.name.trim()) {
            newErrors.name = 'Name is required.';
        }

        if (!/^\d{10}$/.test(formData.phone)) {
            newErrors.phone = 'Phone number must be 10 digits.';
        }

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = 'Invalid email format.';
        }

        if (formData.password.length < 6) {
            newErrors.password = 'Password must be at least 6 characters.';
        }

        if (formData.password !== formData.confPassword) {
            newErrors.confPassword = 'Passwords do not match.';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // Return true if no errors
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            // console.log('Signup Data:', formData);
            // Handle signup logic here (e.g., API call)
            const options = {
                method: "POST",
                url: `${base_url}/signup`,
                headers: {
                    "Content-Type": "application/json"
                },
                data: formData
            }

            try {
                const response = await MakeAxiosCall(options)
                if (response?.data?.data?.status) {
                    // console.log('response---------', response.data.data)
                    alert('User Registerd Successfully')
                    setisSuccessMessage(true)
                    navigate('/login');
                }
            } catch (error) {
                console.log('error', error)
            }

        }
    };

    return (
        <>
        <Seo
  title="Sign Up - KhetBazaar"
  description="Create a KhetBazaar account to start listing or buying land."
  canonical="https://khetbazaar.in/signup"
/>

            <NavbarComponent />
            <div className="signup-container">
                <h2>Create Your Account</h2>
                {isSuccessMessage && (<h2>User Registered Successfuly</h2>)}
                <form className="signup-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="name">Name</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            placeholder="Enter your name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                        {errors.name && <p className="error">{errors.name}</p>}
                    </div>
                    <div className="form-group">
                        <label htmlFor="phone">Phone</label>
                        <input
                            type="text"
                            id="phone"
                            name="phone"
                            placeholder="Enter your phone number"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                        />
                        {errors.phone && <p className="error">{errors.phone}</p>}
                    </div>
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            placeholder="Enter your email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                        {errors.email && <p className="error">{errors.email}</p>}
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            placeholder="Enter your password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                        />
                        {errors.password && <p className="error">{errors.password}</p>}
                    </div>
                    <div className="form-group">
                        <label htmlFor="confPassword">Confirm Password</label>
                        <input
                            type="password"
                            id="confPassword"
                            name="confPassword"
                            placeholder="Enter your confirm password"
                            value={formData.confPassword}
                            onChange={handleChange}
                            required
                        />
                        {errors.confPassword && <p className="error">{errors.confPassword}</p>}
                    </div>
                    <button type="submit" className="signup-button">Sign Up</button>
                </form>
            </div>
            <FooterComponent />
        </>
    );
};

export default Signup;
